import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle: string;
  /** A button on the right, e.g. one that adds to the list below. */
  action?: ReactNode;
  /** A quieter line under the purpose, e.g. why the step is only to look at. */
  note?: string | null;
}

/** The title and one-line purpose at the top of each step of a form. */
export default function StepHeading({ title, subtitle, action, note }: Props) {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{ fontWeight: 700, fontSize: 16, color: "text.primary" }}
        >
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
        {note && (
          <Typography
            variant="caption"
            color="text.secondary"
            component="p"
            sx={{ m: 0, mt: 0.5, lineHeight: 1.5 }}
          >
            {note}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}
